import 'intersection-observer/intersection-observer.js';
import {delineate} from "../lib/delineate";
import * as balanceText from '../lib/balanceText.js';
import "date-input-polyfill/date-input-polyfill.dist.js";
import "es6-object-assign/dist/object-assign-auto.js";
import Modernizr from 'modernizr';

// Global sub-modules
import * as Nav from "./modules/nav";
import * as Pulldowns from "./modules/pulldowns";
import * as Search from "./modules/quickSearch";
import * as ScrollEffects from "./modules/scrollEffects";
import * as FavoritesDisplay from "./modules/favoritesDisplay";
import * as ImageGrid from "./modules/imageGrid";
import * as NavigationSlider from "./modules/navigationSlider";

// Basic modules
import * as Alerts from "./modules/alerts";
import * as Modals from "./modules/modals";
import * as ProductBuyOptions from "./modules/productBuyOptions";
import * as Tabs from "./modules/tabs";
import * as Tooltips from "./modules/tooltips";
import * as FavoriteToggle from "./modules/favoriteToggle";
import * as SeeMoreExpander from "./modules/seeMore";
import * as CenteredCarousel from "./modules/centeredCarousel";

// CMS modules
import * as Accordion from "./modules/accordion";
import * as ContentAndMediaVideo from "./modules/contentAndMedia";
import * as CmsSlider from "./modules/cmsSlider";
import * as CategoryStepSlider from "./modules/categoryStepSlider";
import * as FeaturedRotator from "./modules/featureRotator";
import * as FileInput from "./modules/fileInput";
import * as HeroImage from "./modules/heroImage";
import * as HeroRotator from "./modules/heroRotator";
import * as FinishSwitcher from "./modules/finishSwitcher";
import * as SectionNav from "./modules/SectionNav";
import * as BubbleTooltip from "./modules/bubbleTooltip";
import * as ProjectQueryResults from "./modules/projectQueryResults"


namespace NHW.Main {
	function addModernizrTests() {
		Modernizr.addTest('coarsepointer', function () {
			return Modernizr.mq('(pointer: coarse)') && !Modernizr.mq('(any-pointer: fine)');
		});

		Modernizr.addTest('ie11', function () {
			if (window.navigator.userAgent.match(/Trident\/7\./)) {
				return true;
			} else {
				return false;
			}
		});

		Modernizr.addTest('mobilesafari', function() {
			return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
		});
	}

	function delineateFooterSubnav() {
		new delineate('.js-footer-links');
	}

	function initBalanceText() {
		balanceText();
	}

	function setupBubbleTooltips(){
		if(!$('.bubble-tooltip').length) {
			return;
		}

		BubbleTooltip.init();
	}

	function scrollToTarget() {
		let scrollLinks = document.querySelectorAll('.js-scroll-to-target');

		if(!scrollLinks.length) {
			return;
		}

		scrollLinks.forEach((link) => {
			//scrolls to main article content upon button click
			link.addEventListener('click',function(e){
				let bodyRect = document.body.getBoundingClientRect();
				let linkTarget:any = link.getAttribute('data-target');
				let theLink:any = document.getElementById(linkTarget);
				let rect:any = theLink.getBoundingClientRect();
				let linkTargetOffset:any = rect.top - bodyRect.top;
				e.preventDefault();

				window.scrollTo({
					top: linkTargetOffset,
					behavior:'smooth'
				});
			});
		});
	}

	function scrollToTargetQueryParam() {
		let urlParams = new URLSearchParams(window.location.search);

		//check if urlParms exists for scrolling to a particular id on a page
		if(!urlParams.has('scrollTo')) {
			return;
		}

		let linkTarget = urlParams.get('scrollTo');
		window.addEventListener("load", function() {
			setTimeout(function(){
				let linkTargetOffset:any = document.getElementById(linkTarget) ? document.getElementById(linkTarget).offsetTop : (document.querySelectorAll(`[data-section="${linkTarget}"]`).length ? (document as any).querySelector(`[data-section="${linkTarget}"]`).offsetTop : 0);

				window.scrollTo({
					top: linkTargetOffset,
					behavior:'smooth'
				});
			}, 500);
		});
	}

	function initFeatureRotator(){
		if(!$('.js-feature-rotator').length) {
			return;
		}

		FeaturedRotator.init();
	}

	function initSmoothScroll(){
		$('.js-smooth-scroll').click(function (e) {
			let href = $(this).attr('href');
			let $element = $(href);
			$('body,html').animate({
				scrollTop: $element.offset().top
			}, 800);
			e.preventDefault();
			return false;
		});
	}

	function calculateScrollbarWidth() {
		var $el = $('<div style="width: 100%"></div>');
		$el.appendTo('body');
		var constrainedWidth = $el.width();

		$el.css('width', '100vw');
		var fullWidth = $el.width();
		var scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

		document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
		$el.remove();
	}

	function curalateFixes() {
		let curalateWidget:any = $('.hero-image .curalate-widget');
		let curalateIframe:any = $('.curalate-widget-iframe');


		curalateIframe.each(function(index){
			let $this = $(this);
			let iframeId = `curalateIframe-${index}`;
			$this.attr('frameborder', 0);
			$this.removeAttr('sandbox');
			$this.attr('id', iframeId);
			curalateIframe.attr('scrolling', 'no');
			$this.on('load', function(){
				curalateWidget.addClass('state-visible');
			});
		});

		$('body').on('click', '.js-show-hide-shoppable', function(e){
			let $this = $(e.target);
			let shoppableContainer = $this.closest('.hero-image').find('.hero-image__container--shoppable');
			if(!shoppableContainer.hasClass('state-hidden')) {
				shoppableContainer.addClass('state-hidden');
				$(this).text("Show Image Details");
			} else {
				shoppableContainer.removeClass('state-hidden');
				$(this).text("Hide Details & Shop This Image");
			}
			e.preventDefault();
		});
	}

	var iframeResizeTimeout;

	function resizeIframe() {
		var iframe_id="locatoriframe"; // replace with id of the iframe to dynamically resize
		var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
		var eventer = window[eventMethod];
		var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
		eventer(messageEvent,function(e) {
			if(typeof(e.data) === 'string' && e.data.indexOf("w2gi:iframeHeightUpdated") !== -1) {
				var dimensions = e.data.split("//");
				autoResize(dimensions[1], dimensions[2]);
			}
			if(typeof(e.data) === 'string' && e.data.indexOf("w2gi:scrollPage") !== -1) {
				var offsets = document.getElementById(iframe_id).getBoundingClientRect();
				var values = e.data.split("//");
				var destination = values[1];
				window.scrollTo(0, destination + offsets.top);
			}
		},false);

		function autoResize(newheight, newwidth) {
			// Resizing the iframe triggers the iframe to throw the iframeHeightUpdated event again, which causes
			// an infinite loop of iframe resizing. We will only resize the iframe if it's been at least 1 second since
			// the last resize event
			if (iframeResizeTimeout) { return; }

			document.getElementById(iframe_id).style.minHeight = parseInt(newheight) + 40 + "px";
			document.getElementById(iframe_id).style.maxHeight = parseInt(newheight) + 40 + "px";

			iframeResizeTimeout = setTimeout(function() {
				iframeResizeTimeout = null;
			}, 1000);
		}
	}

	function setExternalLinks() {
		let baseHostName = window.location.hostname;

		$('a[href^=http]').each(function() {
			let $this:any = $(this);
			let $theHref:URL = new URL($this.prop('href'));
			if ( $theHref.hostname != baseHostName && !$(this).attr('target') && !$this.hasClass('js-allow-external') ) {
				$this.addClass('link--external');
				$this.attr('rel', "noopener");
				$(this).attr('target', '_blank');
			}
		});

		$('a[href$=".pdf"], a[href$=".doc"], a[href$=".docx"]').attr('target', '_blank');
	}

	export function init(): void {
		calculateScrollbarWidth();
		addModernizrTests();
		initBalanceText();
		curalateFixes();
		delineateFooterSubnav();
		resizeIframe();
		setExternalLinks();
		initSmoothScroll();
		setupBubbleTooltips();
		initFeatureRotator();
		scrollToTarget();
		CmsSlider.init();
		scrollToTargetQueryParam();
		CategoryStepSlider.init();
		ProjectQueryResults.init();
		NavigationSlider.init();
		// Init global sub-modules
		HeroImage.init();
		FinishSwitcher.init();

		Nav.init();
		ScrollEffects.init();
		Search.init();
		Pulldowns.init();
		FavoritesDisplay.init();
		ImageGrid.init();
		SeeMoreExpander.init();

		// Init basic modules
		Alerts.init();
		FileInput.init();
		Modals.init();
		CenteredCarousel.init();
		ProductBuyOptions.init();
		Tabs.init();
		Tooltips.init();
		FavoriteToggle.init();

		// Init CMS modules
		Accordion.init();
		ContentAndMediaVideo.init();
		HeroRotator.init();
		SectionNav.init();
	}
}

$(document).ready(function () {
	NHW.Main.init();
});
